import { Observable } from 'rxjs/Observable'

export const authenticate = ({
  apiBaseUrl,
  authParams,
}) => {
  return Observable.ajax({
    url: `${apiBaseUrl}/api/auth`,
    method: 'POST',
    crossDomain: true,
    responseType: 'json',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(authParams),
  })
    .retryWhen((errors) => {
      return errors
        .scan((count, error) => {
          if (count >= 3) {
            throw error
          }
          return count + 1
        }, 0)
        .mergeMap((count) => Observable.timer(2 ^ count * 1000))
    })
    .map((data) => {
      return {
        userIpAddress: data.response.remote_ip,
        userId: data.response.user_id,
        sessionToken: data.response.session_token,
      }
    })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/socket/api.js